import { render } from "./topbar.vue?vue&type=template&id=b270a678&scoped=true"
import script from "./topbar.vue?vue&type=script&lang=js"
export * from "./topbar.vue?vue&type=script&lang=js"

import "./topbar.vue?vue&type=style&index=0&id=b270a678&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b270a678"]])

export default __exports__